var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3255 10L15.0364 6.28907C15.2125 6.11326 15.3116 5.87469 15.3118 5.62584C15.312 5.37699 15.2134 5.13824 15.0376 4.96212C14.8618 4.786 14.6232 4.68693 14.3743 4.68671C14.1255 4.68649 13.8867 4.78514 13.7106 4.96095L9.99967 8.67188L6.28874 4.96095C6.11261 4.78483 5.87374 4.68588 5.62467 4.68588C5.3756 4.68588 5.13673 4.78483 4.96061 4.96095C4.78449 5.13707 4.68555 5.37594 4.68555 5.62501C4.68555 5.87408 4.78449 6.11295 4.96061 6.28907L8.67155 10L4.96061 13.7109C4.78449 13.8871 4.68555 14.1259 4.68555 14.375C4.68555 14.6241 4.78449 14.8629 4.96061 15.0391C5.13673 15.2152 5.3756 15.3141 5.62467 15.3141C5.87374 15.3141 6.11261 15.2152 6.28874 15.0391L9.99967 11.3281L13.7106 15.0391C13.8867 15.2152 14.1256 15.3141 14.3747 15.3141C14.6237 15.3141 14.8626 15.2152 15.0387 15.0391C15.2149 14.8629 15.3138 14.6241 15.3138 14.375C15.3138 14.1259 15.2149 13.8871 15.0387 13.7109L11.3255 10Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f472e3efc7821d9ac54a27cd0b375bc5.svg";
export { ForwardRef as ReactComponent };